import { createRoot } from 'react-dom/client';
import { getMediaQuerySizesFromAttributes } from '@repo/common-utils/mediaQueryAttributeInputHelper';
import { getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import { getCsvColorsAttributes } from '@repo/widget-utils/attributes/color-attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import SmartEventList from './SmartEventList';

class BilberrySmartEventList extends BilberryCustomElement {
    protected renderWidget(): void {
        const id = Number(this.getAttribute('smart-event-id'));
        const hideReadMore = getYesAttribute(this, 'hide-read-more');

        const numElements = getMediaQuerySizesFromAttributes(this, 1, 2, 3, 3);

        const scrollAttribute = this.getAttribute('scroll');
        const scroll = !(scrollAttribute && scrollAttribute!.toString().toLowerCase() === 'no');
        const colors = getCsvColorsAttributes(this);

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <SmartEventList
                    id={id}
                    hideReadMore={hideReadMore}
                    numElements={numElements}
                    scroll={scroll}
                    backgroundColors={colors.backgroundColors}
                    textColors={colors.textColors}
                    primaryColors={colors.primaryColors}
                    primaryTextColors={colors.primaryTextColors}
                    accentColors={colors.accentColors}
                    accentTextColors={colors.accentTextColors}
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-smart-event-list', BilberrySmartEventList);
}
